import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/course-of-study";

export type listType = {
  keyword?: number;
  limit?: number;
  page?: number;
};

export type getOneLunchType = {
  id_faculty?: number;
  id_degree?: number;
}

export class CourseOfStudyApi extends BaseAPI {
  static list(query: listType): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
  static findById(id: any): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
  static patch(body: any, id: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }
  static academicDetail(id_academic_year: any): Promise<AxiosResponse> {
    return this.api.get(`${path}/academic/${id_academic_year}/get-one`);
  }
  static academicDetailLunch(id_academic_year: number, params?: getOneLunchType): Promise<AxiosResponse> {
    return this.api.get(`${path}/academic/${id_academic_year}/get-one-lunch`, { params });
  }
  static academicCreate(body: any, id: any): Promise<any> {
    return this.api.put(`${path}/academic/${id}/create`, body);
  }
  static academicDataDropdown(query?: any): Promise<any> {
    return this.api.get(`${path}/academic/data-dropdown-select`, {
      params: { ...query },
    });
  }
  static coursetTuitionFees(body: any, id: any): Promise<any> {
    return this.api.put(`${path}/${id}/course-tuition-fees`, body);
  }
  static getCoursetTuitionFees(id: any): Promise<any> {
    return this.api.get(`${path}/${id}/course-tuition-fees`);
  }
  static delete(id: any): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }



  static getByFaculty(id_faculty: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/get-by-faculty`, { params: { id_faculty } })
  }
}
